module.exports = __webpack_public_path__ + "static/si-logo-08baf7503447b57d9921fd8c6e65755e.png";